import { Box } from "@mui/material";
import styles from "./loader-spinner.module.scss";

export default function LoaderSpinner() {
  return <Box className={styles.loader}></Box>;
}